import React, { useState } from "react";
import { CardComp } from "../../../../components";
import FallbackImage from "../../../../components/Common/ImageWrapper";
import TableSkeletonLoader from "../../../../components/Common/TableSkeletonLoader";
import { useGetStaffReceivedWishesQuery } from "../../../../store/admin/automatedBirthdaySlice";
import moment from "moment";
import { convertToTitleCase } from "../../../../utils/helpers";

const StaffReceivedWishes = () => {
  const [page, setPage] = useState(1);
  const { data, isLoading, isFetching } = useGetStaffReceivedWishesQuery(page);

  const wishes = data?.wishes?.data || data?.wishes || [];
  const pagination = data?.pagination || {};

  if (isLoading) {
    return (
      <div className="row g-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="col-lg-6">
            <CardComp cardClassName="border-0 shadow-sm rounded-4 h-100">
              <div className="p-4">
                <TableSkeletonLoader rows={2} columns={1} />
              </div>
            </CardComp>
          </div>
        ))}
      </div>
    );
  }

  if (wishes.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5 mt-4">
        <div className="col-lg-7 text-center bg-white p-5 rounded-4 shadow3 border-0 animate__animated animate__fadeIn">
          <div 
            className="mb-4 d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm"
            style={{ 
              width: '100px', 
              height: '100px', 
              background: 'linear-gradient(135deg, rgba(139, 49, 58, 0.1) 0%, rgba(49, 119, 140, 0.1) 100%)',
              fontSize: '40px'
            }}
          >
            💌
          </div>
          <h4 className="fw-bold text-black1 mb-2">No Wishes Yet</h4>
          <p className="text-blacklight mb-0">
            When members or colleagues send you birthday wishes, they will appear here!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="row g-4">
      {wishes.map((wish, i) => (
        <div key={i} className="col-lg-6">
          <CardComp cardClassName="border-0 shadow-sm rounded-4 h-100 hover:shadow-md transition-all">
            <div className="p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-3">
                  <FallbackImage
                    src={wish.sender?.photo || "/Staff/avatar.svg"}
                    width="48px"
                    height="48px"
                    className="rounded-circle border"
                  />
                  <div>
                    <h6 className="fw-bold text-black1 mb-0">
                      {wish.sender?.first_name} {wish.sender?.last_name}
                    </h6>
                    <p className="text-blacklight small mb-0">
                      {wish.sender_type?.includes('Member') ? 'Member' : 
                       wish.sender_type?.includes('Staff') ? 'Admin' : 'System'}
                    </p>
                  </div>
                </div>
                <div className="text-blacklight small">
                  {moment(wish.created_at).fromNow()}
                </div>
              </div>
              <div 
                className="bg-light p-3 rounded-4 border-start border-primary1 border-4 italic"
                dangerouslySetInnerHTML={{ 
                  __html: wish.message ? wish.message.replace(/^"|"$/g, '') : "" 
                }}
              />
            </div>
          </CardComp>
        </div>
      ))}
      
      {pagination.totalPages > 1 && (
        <div className="col-12 d-flex justify-content-center mt-4">
          <div className="d-flex gap-2">
            <button 
              className="btn btn-sm border-0 bg-white shadow-sm rounded-pill px-3"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>
            <span className="align-self-center small fw-bold">Page {page} of {pagination.totalPages}</span>
            <button 
              className="btn btn-sm border-0 bg-white shadow-sm rounded-pill px-3"
              disabled={page === pagination.totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffReceivedWishes;
